// extracted by mini-css-extract-plugin
export default {"block":"XSKT0","readOnlyBlock":"bsDVY","blockText":"_ul1E","item":"vcIaP","itemOrder":"WvuEL","itemOrderText":"IEv9j","itemPropertyType":"JNxqE","itemText":"Qml8A"};